import { NavSection } from '@/components/nav-section'
import { NavUser } from '@/components/nav-user'
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
	useSidebar,
} from '@/components/ui/sidebar'
import { WorkspaceSwitcher } from '@/components/workspace-switcher'
import { HoneyGridIcon } from '@/icons/HoneyGridIcon/HoneyGridIcon'
import { useStytchMember } from '@stytch/react/b2b'
import { Settings, PanelLeft, ShoppingCart, Inbox } from 'lucide-react'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import { WorkspaceSelector } from './WorkspaceSelector'
import { useUnreadCountQuery } from '@/queries/conversations/useConversationsQuery'

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const { workspaceId = '' } = useParams()
	const { member } = useStytchMember()
	const { toggleSidebar, state } = useSidebar()
	const { data: unreadCount = 0 } = useUnreadCountQuery()

	const menuItems = [
		{
			title: 'Collapse sidebar',
			url: '#',
			icon: PanelLeft,
			onClick: (e: React.MouseEvent) => {
				e.preventDefault()
				toggleSidebar()
			},
			// Tooltip shows when collapsed - should say "Expand sidebar" when collapsed
			tooltip: state === 'collapsed' ? 'Expand sidebar' : 'Collapse sidebar',
		},
		{
			title: 'Inbox',
			url: '#',
			icon: Inbox,
			// Show count badge when expanded, dot when collapsed
			badge: state === 'expanded' ? unreadCount : undefined,
			unreadIndicator: state === 'collapsed' && unreadCount > 0,
			onClick: (e: React.MouseEvent) => {
				e.preventDefault()
				// Trigger inbox modal via custom event
				window.dispatchEvent(new CustomEvent('openInboxModal'))
			},
		},
		{
			title: 'Orders',
			url: `/${workspaceId}/orders`,
			icon: ShoppingCart,
		},
		{
			title: 'Grids',
			url: `/${workspaceId}/grids`,
			icon: HoneyGridIcon,
		},
		{
			title: 'Settings',
			url: `/${workspaceId}/settings`,
			icon: Settings,
			matchPattern: `/${workspaceId}/settings.*`,
		},
	]


	// Transform Stytch member data to match the expected format
	const user = member
		? {
				name: member.name || member.email_address,
				email: member.email_address,
				avatar: '/avatars/default.jpg', // Use a default avatar for now
			}
		: {
				name: 'Loading...',
				email: '',
				avatar: '/avatars/default.jpg',
			}

	return (
		<>
			<Sidebar collapsible="icon" {...props}>
				<SidebarHeader>
					<WorkspaceSwitcher />
				</SidebarHeader>
				<SidebarContent>
					<NavSection items={menuItems} />
				</SidebarContent>
				<SidebarFooter>
					<NavUser user={user} />
				</SidebarFooter>
				<SidebarRail />
			</Sidebar>
			<WorkspaceSelector />
		</>
	)
}
